import SEO from 'app/components/SEO/SEO';
import React from 'react';
import { useSelector } from 'react-redux';
import { makeSelectedEvent } from './slice/selectors';
import { useTranslation } from 'react-i18next';
import oveitLogo from '../../../assets/common/oveit-logo.svg';

const TicketSalePageMeta = () => {
  const { t } = useTranslation();
  const selectedEvent = useSelector(makeSelectedEvent);

  const pageTitle = !selectedEvent.name
    ? ''
    : t('ticketSale.pageTitle', {
        eventName: selectedEvent.name,
      });
  const pageDescription = t('ticketSale.pageDescription', {
    eventName: selectedEvent.name,
  });
  const pageImage = selectedEvent.cover?.original;

  return (
    <SEO
      pageTitle={pageTitle}
      pageDescription={pageDescription}
      pageImage={pageImage || oveitLogo}
    />
  );
};

export default TicketSalePageMeta;
